import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {CustomValidators} from '@core/validator/custom-validators';
import {CreateCoordinator} from './create-coordinator.model';
import {AlertService} from '@widgets/alert/alert.service';
import {ValidatorService} from '@core/validator/validator.service';
import {TranslateService} from '@ngx-translate/core';
import {CoordinatorsService} from '@core/ecv-http-services/services/coordinators.service';
import {AlertUtils} from '../shared/AlertUtils';
import {ChangePassword} from './change-password.model';

@Component({
  selector: 'app-coordinators',
  templateUrl: './coordinators.component.html'
})

export class CoordinatorsComponent implements OnInit {
  private static coordinatorSuffix = '.koordynator';

  newCoordinatorForm: FormGroup;
  changePasswordForm: FormGroup;
  createCoordinatorModel: CreateCoordinator = new CreateCoordinator();
  changePasswordModel: ChangePassword = new ChangePassword();

  constructor(private translateService: TranslateService,
              private alertService: AlertService,
              private coordinatorsService: CoordinatorsService,
              private validatorService: ValidatorService) {
  }

  ngOnInit() {
    this.createCoordinatorForm();
    this.createPasswordForm();
  }

  saveCoordinator() {
    this.validatorService.validate(this.newCoordinatorForm);
    if (!this.validatorService.isValid(this.newCoordinatorForm)) {
      return;
    }
    this.createCoordinatorModel.username = this.generateUserName();
    this.coordinatorsService.createCoordinator(this.createCoordinatorModel)
      .subscribe(response => {
        AlertUtils.showAlert(true, 'ALERT.COORDINATOR_CREATED', this.translateService, this.alertService);
        this.createCoordinatorModel = new CreateCoordinator();
        this.createCoordinatorForm();
      });
  }

  setRandomPassword() {
    this.createCoordinatorModel.password = this.generateRandomPassword();
  }

  setRandomNewPassword() {
    this.changePasswordModel.newPassword = this.generateRandomPassword();
  }

  saveNewPassword() {
    this.validatorService.validate(this.changePasswordForm);
    if (!this.validatorService.isValid(this.changePasswordForm)) {
      return;
    }
    this.coordinatorsService.changePassword(this.changePasswordModel)
      .subscribe(response => {
        AlertUtils.showAlert(true, 'ALERT.PASSWORD_CHANGED', this.translateService, this.alertService);
        this.changePasswordModel = new ChangePassword();
        this.createPasswordForm();
      });
  }

  getUserName(): string {
    if (this.createCoordinatorModel.firstName && this.createCoordinatorModel.lastName) {
      return this.generateUserName();
    }
    return '';
  }

  private createCoordinatorForm() {
    this.newCoordinatorForm = new FormGroup({
      'firstName': new FormControl('', {validators: [CustomValidators.notEmpty, CustomValidators.validateName]}),
      'lastName': new FormControl('', {validators: [CustomValidators.notEmpty, CustomValidators.validateName]}),
      'email': new FormControl('', [CustomValidators.notEmpty, CustomValidators.validateNotEmptyEmail]),
      'username': new FormControl('', {validators: [CustomValidators.notEmpty]}),
      'password': new FormControl('', {validators: [CustomValidators.notEmpty]})
    });
  }

  private createPasswordForm() {
    this.changePasswordForm = new FormGroup({
      'username': new FormControl('', {validators: [CustomValidators.notEmpty]}),
      'password': new FormControl('', {validators: [CustomValidators.notEmpty]})
    });
  }

  private generateRandomPassword(): string {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 16; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  private generateUserName(): string {
    return (this.createCoordinatorModel.firstName + '.' + this.createCoordinatorModel.lastName + CoordinatorsComponent.coordinatorSuffix)
      .toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/coordinators/coordinators.component.ts